import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { toggleMobileAsideMenu, closeMobileAsideMenu } from '../../actions';
import { logOut } from '../../actions/auth';
import logo from '../../images/logo.png';
import AccountMenu from './AccountMenu';
import NavMenuLinks from './NavMenuLinks';
import defaultUserPhoto from '../../images/default_user.png';
import UsersService from '../../services/UsersService';
import { employerNavMenuLinks } from '../../constants/navMenuLinks';

class NavBar extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    asideMenuIsOpen: PropTypes.bool.isRequired,
    asideMenuIsAvailable: PropTypes.bool.isRequired,
    logOut: PropTypes.func.isRequired,
    toggleMobileAsideMenu: PropTypes.func.isRequired,
    closeMobileAsideMenu: PropTypes.func.isRequired,
    totalUnreadMessages: PropTypes.number.isRequired
  };

  static contextTypes = {
    router: PropTypes.object
  };

  render () {
    const { asideMenuIsOpen, toggleMobileAsideMenu, closeMobileAsideMenu, user, totalUnreadMessages, logOut, history } = this.props;
    const { userid, photo_image_url, first_name, last_name } = user;
    const fullName = `${first_name} ${last_name}`;
    const isAdmin = UsersService.isAdmin();
    return (
      <nav className='top-nav-menu'>
        { userid && isAdmin && this.props.asideMenuIsAvailable && (
          <div
            className='hamburger-icon'
            onClick={toggleMobileAsideMenu}
          >
            <FontAwesomeIcon icon={faBars} size='lg' />
          </div>
        )}
        <div className={`logo-wrapper ${isAdmin ? 'admin' : ''}`}>
          <NavLink to='/' className='nav-logo'>
            <img src={logo} alt='Gravy Logo' />
          </NavLink>
        </div>
        <div className='nav-links-wrapper'>
          <div>
            <span className='text-black text-md ml-5 banner-top'>Coming Soon: a sleek new look and brand new features. Stay tuned for GravyWork 2.0!</span>
          </div>
        </div>
        { UsersService.isEmployer() && (
          <div className='nav-links-wrapper'>
            <div className='delimiter' />
            { employerNavMenuLinks.map((link, index) => (
              <NavLink className='top-employer-nav-link' key={index} to={link.to}>
                {link.title} {` `}
                {link.title === 'Messages' && totalUnreadMessages > 0 && (
                  <span className='unread-messages-count'>{totalUnreadMessages}</span>
                )}
              </NavLink>
            ))}
          </div>
        )}
        {userid && (
          <div className='user-info'>
            <img className='user-photo' src={photo_image_url || defaultUserPhoto} alt='' />
            <AccountMenu
              fullName={fullName}
              closeMobileAsideMenu={closeMobileAsideMenu}
              logOut={logOut}
              history={history}
            />
          </div>
        )}
        { isAdmin && asideMenuIsOpen && (
          <aside className='aside menu-mobile'>
            <NavMenuLinks
              closeMobileAsideMenu={closeMobileAsideMenu}
              totalUnreadMessages={totalUnreadMessages}
            />
          </aside>
        )}
      </nav>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    asideMenuIsOpen: state.asideMenuIsOpen,
    asideMenuIsAvailable: state.asideMenuIsAvailable,
    totalUnreadMessages: state.conversations.totalUnreadMessages
  };
};

export default withRouter(connect(mapStateToProps, { logOut, toggleMobileAsideMenu, closeMobileAsideMenu })(NavBar));



// WEBPACK FOOTER //
// ./src/components/navigation/NavBar.js